import { render, staticRenderFns } from "./ApprovalRequests.vue?vue&type=template&id=04c1c39b&scoped=true"
import script from "./ApprovalRequests.vue?vue&type=script&lang=js"
export * from "./ApprovalRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1c39b",
  null
  
)

export default component.exports